
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/senzacni/ramzova",
      function () {
        return require("private-next-pages/_subdomains/senzacni/ramzova.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/senzacni/ramzova"])
      });
    }
  